import React from 'react'

export default function(props) {
  const { result } = props
  const textClass = result.image ? 'text' : 'text-only'
  const resultTitle = result.title
  const endDate = result.endDate ? new Date(result.endDate.date) : ''
  const options = { month: 'long', day: 'numeric', year: 'numeric' }
  const dateString = endDate ? `Ends ${endDate.toLocaleDateString("en-US", options)}` : ''
  
  return (
    <>
      {result.image && (
        <div className="image">
          <img src={result.image}/>
        </div>
      )}
      <div className={textClass}>
        <h3 className="result-title">{resultTitle}</h3>
        <p className="result-date" dangerouslySetInnerHTML={{ __html: dateString }} />
        <div dangerouslySetInnerHTML={{ __html: result.text }} />
      </div>
    </>
  )
}